import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=3cdbf57c&scoped=true&%3Akey=message.ID&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=3cdbf57c&prod&lang=less&scoped=true&"
import style1 from "./Message.vue?vue&type=style&index=1&id=3cdbf57c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbf57c",
  null
  
)

export default component.exports